export default __webpack_public_path__ + "static/media/iside-logo.c1c9e511.png";